import React, { createContext, useState, useContext, useEffect } from 'react';

const DataContext = createContext();

export function DataProvider({ children }) {
  const [data, setData] = useState({
    loading: true,
    error: null,
    stats: null,
    billionaires: null,
    dataSources: null,
    lastUpdated: null,
    cached: false
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://wealth-inequality-api.e-c0f.workers.dev', {
          headers: {
            'Accept': 'application/json',
            'Origin': window.location.origin
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const jsonData = await response.json();
        console.log('Fresh API data:', jsonData); // Debug log
        
        if (!jsonData.dataSources) {
          throw new Error('Invalid API response: missing dataSources');
        }
        
        setData({
          loading: false,
          error: null,
          stats: jsonData.stats,
          billionaires: jsonData.billionaires,
          dataSources: jsonData.dataSources,
          lastUpdated: jsonData.lastUpdated,
          cached: false
        });
      } catch (error) {
        console.error('Error fetching data:', error);
        setData({
          loading: false,
          error: error.message,
          stats: null,
          billionaires: null,
          dataSources: null,
          lastUpdated: null,
          cached: false
        });
      }
    };

    fetchData();
  }, []);

  return (
    <DataContext.Provider value={data}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  return useContext(DataContext);
} 